import { parse as remoteParse } from "./firebase/parse";

export interface ProductParams {
    title: string;
    price: string;
    currency: string;
    description: string;
    imageURL: string;
}

export async function parse(url: string): Promise<ProductParams> {
    const result = await remoteParse({ url });

    console.log(result);

    return result.data as ProductParams;
}
